// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1A6nj","lds-ring":"Loader_lds-ring__3cKWI"};